import { memo, useContext, useEffect, useRef, useState } from "react";
import { Modal, Form, Accordion, Spinner } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import down_arrow from '../../../assets/images/downArrow2.svg';
import close from "../../../assets/images/close.svg";
import Axe from "../../../assets/images/sidebar/icons/axeMark.svg";
import { PostCallWithErrorResponse, PostCallWithErrorResponseReqBody, multipartPostCallWithErrorResponse, simpleGetCallWithErrorResponse, simplePostCallForm } from "../../../api/ApiServices";
import ApiConfig from "../../../api/ApiConfig";
import { ToastMsg } from "../../TostMsg";
import { AppContext } from "../../../context/AppContext";
import CustomSelect from "../../../sharedComponent/customSelect";
import TaskList from "../TaskList";

const CreateTaskPlanner = memo((props) => {

    const {
        masterData,
        getMasterData
    } = useContext(AppContext)

    const { isAddTaskPlan, setIsAddTaskPlanner, getTaskList } = props

    const [isValidated, setIsValidated] = useState(false)

    const [isSaving, setIsSaving] = useState(false)



    const [projectyNames, setProjectNames] = useState([])

    const [validated, setValidated] = useState(false)

    const [roles, setRoles] = useState([])

    const [showTaskDetails, setSHowTaskDetails] = useState(false)

    const [isGeneratingTask, setIsGeneratingTask] = useState(false)

    const [tasksList, setTasks] = useState({})

    const initialTask = {
        file: "",
        projectId: '',
        fileName: ''
    }

    const ref = useRef(null)

    const [taskDetails, setTaskDetails] = useState(initialTask)


    useEffect(() => {
        getProjectName()
    }, [])


    const getRoles = () => {

        PostCallWithErrorResponse(ApiConfig.SEARCH_ROLE_API, JSON.stringify({ Name: '' })).then((res) => {
            if (res?.json?.Success) {
                setRoles(res?.json?.Data)
            }
        })

    }


    const getProjectName = () => {



        simpleGetCallWithErrorResponse(ApiConfig.GET_PROJECTS_NAMES).then(
            (res) => {
                if (res?.json?.Success) {
                    setProjectNames(res?.json?.Data?.filter((prjct) => prjct?.Status === 'Active'));
                }
            }
        );

    }

    const handleChange = (key, value) => [

        setTaskDetails(prev => ({
            ...prev,
            [key]: value
        }))

    ]


    const generateTask = (event) => {

        const form = event.currentTarget;

        event.preventDefault();

        if (form.checkValidity() === false) {

            event.stopPropagation();
        }

        setValidated(true)

        if (!taskDetails?.file || !taskDetails?.projectId) {
            ToastMsg('error', 'Please Select Project Name And Document')
            return
        }

        setIsGeneratingTask(true)

        if (form.checkValidity()) {

            let formData = new FormData()



            formData.append('file', taskDetails?.file)

            multipartPostCallWithErrorResponse(ApiConfig.GET_TASK_PLANNER_DATA, formData).then((res) => {

                if (res?.json?.data) {
                    setTasks(res?.json?.data)
                    setSHowTaskDetails(true)
                    if (!roles?.length) {
                        getRoles()
                    }

                } else {
                    ToastMsg('error', 'Something went wrong try again!')
                }

                setIsGeneratingTask(false)


            })
        }


    }

    const handleTechBreakdownChange = (field, value, isArray = false, index, subKey) => {

        setTasks((prev) => {
            if (isArray) {
                return {
                    ...prev,
                    [field]: prev[field].map((item, i) =>
                        i === index
                            ? { ...item, [subKey]: value }
                            : item
                    ),
                };
            }

            return {
                ...prev,
                [field]: value,
            };
        });


    };

    const addStep = () => {
        const step = {
            step_id: "",
            task: "",
            activity: [],
            hours: "",
            complexity_level: "",
            assigned_role: "",
            dependency_step_id: null,
        };

        const breakdown = tasksList?.technical_breakdown || [];

        handleTechBreakdownChange("technical_breakdown", [...breakdown, step]);

    }

    const handleRemove = (index) => {
        let dedacteHour = tasksList?.technical_breakdown[index]?.hours

        let remove = tasksList?.technical_breakdown?.filter((_, i) => i != index)


        handleTechBreakdownChange('budget_hours_total', tasksList?.budget_hours_total - dedacteHour)
        handleTechBreakdownChange("technical_breakdown", remove)


    }

    const handlePublish = () => {

        let isValid = true


        if (!tasksList?.title ||
            !tasksList?.story_points_suggested ||
            !tasksList?.budget_hours_total
        ) {
            isValid = false
            setIsValidated(true)
        }

        tasksList?.technical_breakdown?.forEach((i, index) => {

            if (!i?.task ||
                !i?.hours ||
                !i?.assigned_role ||
                !i?.complexity_level
            ) {
                isValid = false
                setIsValidated(true)
            }

        })

        if (isValid) {

            setIsSaving(true)

            PostCallWithErrorResponse(ApiConfig.PUBLISH_TASK_PLANNER + `projectid=${taskDetails?.projectId}&filename=${taskDetails?.fileName}&isPublish=true`, JSON.stringify({ data: tasksList })).then((res) => {

                if (res?.json?.success) {
                    ToastMsg('success', res?.json?.message)

                    setIsAddTaskPlanner(false)
                    getTaskList()
                    setSHowTaskDetails(false)
                } else {
                    ToastMsg('error', res?.json?.message)
                }

                setIsSaving(false)

            })
        } else {
            ToastMsg('error', 'PLease Fill All Field ')
        }


    }



    return (
        <>
            <Modal
                size="xl"
                show={isAddTaskPlan}
                onHide={() => {
                    setIsAddTaskPlanner(false)
                    setIsGeneratingTask(false)
                }}
                aria-labelledby="modal-90w"
                className="add-task-modal-main"
                centered
            >
                <Modal.Header className="add-task-modal-header ">
                    <Modal.Title id="example-modal-sizes-title-lg">Create Task</Modal.Title>
                    <div className="rightAxe">
                        <img src={Axe} alt=""
                            onClick={() => setIsAddTaskPlanner(false)}
                        />
                    </div>
                </Modal.Header>
                <div className="lineSeperate"></div>
                <div style={{ minHeight: '200px' }}>
                    {
                        isGeneratingTask ? <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "200px",
                        }}>

                            <h2 style={{ display: "flex", alignItems: "center", gap: "8px" }}> Please Wait ! Task Details generating <Spinner animation="grow" style={{ width: "16px", height: "16px" }} /></h2>
                        </div> :
                            <Form noValidate
                                validated={validated} onSubmit={generateTask}
                            >
                                <Modal.Body>
                                    <div className="mainContentmodel">
                                        <div className="row align-items-center" id="popup-form-af">

                                            {/* Project Dropdown */}
                                            <div className="col-lg-4 mb-3">
                                                <label className="mb-2" style={{ fontSize: "14px" }}>
                                                    Project
                                                </label>
                                                <div style={{ marginTop: '-20px' }}>
                                                    <CustomSelect
                                                        options={projectyNames}
                                                        labelKey="ProjectName"
                                                        valKey="ProjectId"
                                                        value={taskDetails?.projectId}
                                                        handleChange={(e) => {

                                                            handleChange('projectId', e)
                                                        }}
                                                    />
                                                </div>

                                                <div className="invalid-feedback">Please select project</div>
                                            </div>

                                            {/* File Attachment */}

                                            <div className="col-lg-6 mb-3">
                                                <label className="mb-2">File Attachment <span style={{ color: 'var(--blue_53B7E8_LightMode)' }}>{taskDetails?.fileName} </span></label>

                                                <div className="d-flex align-items-center gap-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        style={{
                                                            backgroundColor: "#53b7e8",
                                                            color: "white",
                                                            border: "none",
                                                        }}
                                                        onClick={() => ref.current.click()}
                                                    >
                                                        Choose File
                                                    </button>
                                                </div>

                                                <input
                                                    type="file"
                                                    ref={ref}
                                                    style={{ display: "none" }}
                                                    accept=".pdf,.doc,.docx"
                                                    // value={taskDetails?.file}
                                                    required
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file) {
                                                            handleChange("file", file);
                                                            handleChange("fileName", file.name);
                                                        }
                                                    }}
                                                />

                                                {/* File Name Preview */}
                                                {/* {(cliendDet?.ClientLogoFileName || cliendDet?.clientLogoPath) && (
                                        <p className="small text-muted mt-2">
                                            {cliendDet?.ClientLogoFileName ||
                                                cliendDet?.clientLogoPath?.split("/").pop()}
                                        </p>
                                    )} */}
                                            </div>
                                        </div>

                                    </div>
                                </Modal.Body>

                                <div className="lineSeperate"></div>
                                <div className="d-flex justify-content-end align-items-center mainBtnsSub">
                                    <button
                                        type="button"
                                        className="btn-width cancelBtn mx-3"
                                        onClick={() => setIsAddTaskPlanner(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn-width saveBtn"
                                        type='sub,it'
                                        disabled={isGeneratingTask}

                                    >
                                        {isGeneratingTask ? (
                                            <div className="d-flex justify-content-center align-items-center">
                                                <ClipLoader color="#fff" size={18} className="me-2" />
                                            </div>
                                        ) : (
                                            "Create"
                                        )}
                                    </button>
                                </div>
                            </Form>
                    }
                </div>
            </Modal >
            <Modal
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => setSHowTaskDetails(false)}
                show={showTaskDetails}
                className="create-workflow-main modal-lg"
                size="xl"
            >
                <Modal.Header>
                    <Modal.Title>
                        <label className="create-role-text">Create TaskFlow</label>
                    </Modal.Title>
                    <img src={close} alt=""
                        onClick={() => setSHowTaskDetails(false)}
                    />
                </Modal.Header>

                <div className="hr-line-modal">
                    <hr style={{ margin: 0 }} />
                </div>

                <Modal.Body>
                    <div
                        style={{
                            maxHeight: "580px",
                            overflowX: "scroll",
                            scrollbarWidth: "none",
                        }}
                    >
                        {/* Top Inputs */}
                        <div className="row create-workflow-topbody ">
                            <div className="col-lg-6 mt-4">
                                <label className="text-grey">Title</label>
                                <input
                                    type="text"
                                    className="form-control tasKCategory1"
                                    placeholder="Taskflow Name"
                                    value={tasksList?.title}
                                    onChange={(e) => handleTechBreakdownChange('title', e.target.value)}
                                />
                                <p className="text-danger">{isValidated && !tasksList?.title && "Please Enter Task Name"}</p>
                            </div>

                            <div className="col-lg-3 mt-4">
                                <label className="text-grey">StoryPoint Suggested</label>
                                <input
                                    type="number"
                                    className="form-control tasKCategory1"
                                    placeholder="Enter StoryPoint"
                                    value={tasksList?.story_points_suggested}
                                    onChange={(e) => handleTechBreakdownChange('story_points_suggested', e.target.value)}
                                />
                                <p className="text-danger">{isValidated && !tasksList?.story_points_suggested && "Please Enter Story Point"}</p>
                            </div>
                        </div>

                        <div className="row create-workflow-topbody ">
                            <div className="col-lg-3 mt-4">
                                <label className="text-grey">Budgeted Hours</label>
                                <input
                                    type="number"
                                    className="form-control tasKCategory1"
                                    placeholder="Enter BudgetedHours"
                                    value={tasksList?.budget_hours_total}
                                    onChange={(e) => handleTechBreakdownChange('budget_hours_total', Number(e.target.value) || '')}
                                />
                                <p className="text-danger">{isValidated && !tasksList?.budget_hours_total && "Please Enter Budget Hour Point"}</p>
                            </div>

                            <div className="col-lg-12 mt-4">
                                <label className="text-grey">Acceptance Criteria</label>
                                <ul>
                                    {
                                        tasksList?.acceptance_criteria?.map((acceptence, index) => {
                                            return <li key={index}>{acceptence}</li>
                                        })
                                    }
                                </ul>

                            </div>
                        </div>

                        {/* Accordion Sample Step */}
                        <Accordion defaultActiveKey="0">
                            {
                                tasksList?.technical_breakdown?.map((task, index) => {
                                    return <Accordion.Item eventKey={index} className="mt-2">
                                        <Accordion.Header>
                                            <div
                                                className="menus-items w-100 d-flex justify-content-between"
                                                style={{
                                                    backgroundColor: "whiteSmoke",
                                                    padding: "15px",
                                                }}
                                            >
                                                <div className="d-flex gap-1">
                                                    <h5>{task?.step_id}</h5>
                                                    <img src={down_arrow} height={24} alt="down arrow"

                                                    />
                                                </div>
                                                <img src={close} alt=""
                                                    onClick={() => handleRemove(index)}
                                                />
                                            </div>
                                        </Accordion.Header>

                                        <Accordion.Body>
                                            <div className="p-4">
                                                <div className="row create-workflow-topbody pb-4">
                                                    <div className="col-lg-12 row">
                                                        <div className="col-lg-5">
                                                            <label className="text-grey">Task Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control tasKCategory1"
                                                                placeholder="Enter a task"
                                                                value={task?.task}
                                                                onChange={(e) => handleTechBreakdownChange('technical_breakdown', e.target.value, true, index, 'task')}
                                                            />
                                                            <p className="text-danger">{isValidated && !task?.task && "Please Enter Task Name"}</p>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-3 mt-3">
                                                        <label className="text-grey">Hours</label>
                                                        <input
                                                            type="number"
                                                            className="form-control tasKCategory1"
                                                            placeholder="Enter a Hour"
                                                            value={task?.hours}
                                                            onChange={(e) => handleTechBreakdownChange('technical_breakdown', Number(e.target.value) || '', true, index, 'hours')}
                                                        />
                                                        <p className="text-danger">{isValidated && !task?.hours && "Please Enter Hours"}</p>
                                                        {/* <select className="form-select tasKCategory1">
                                                            <option value="">Select BudgetedHours</option>
                                                            <option value="1">Example 1</option>
                                                            <option value="2">Example 2</option>
                                                        </select> */}
                                                    </div>

                                                    <div className="col-lg-3 mt-3">
                                                        <label className="text-grey">Assigned Roles</label>
                                                        <select className="form-select tasKCategory1"
                                                            value={task?.assigned_role}
                                                            onChange={(e) => handleTechBreakdownChange('technical_breakdown', e.target.value, true, index, 'assigned_role')}
                                                        >
                                                            <option value="" disabled selected>
                                                                Assigned Roles
                                                            </option>

                                                            {

                                                                roles?.map((role, index) => {
                                                                    return <option value={role?.Name} key={index}>
                                                                        {role?.Name}
                                                                    </option>
                                                                })
                                                            }
                                                        </select>
                                                        <p className="text-danger">{isValidated && !task?.assigned_role && "Please Select Role"}</p>
                                                    </div>

                                                    <div className="col-lg-3 mt-3">
                                                        <label className="text-grey">Complexity</label>
                                                        <input
                                                            type="text"
                                                            className="form-control tasKCategory1"
                                                            placeholder="complexity level"
                                                            value={task?.complexity_level}
                                                            onChange={(e) => handleTechBreakdownChange('technical_breakdown', e.target.value, true, index, 'complexity_level')}
                                                        />
                                                        <p className="text-danger">{isValidated && !task?.complexity_level && "Please Enter Complexity"}</p>
                                                    </div>
                                                    <div className="col-lg-12 mt-2">

                                                        {
                                                            task?.activities?.map((i, index) => {
                                                                return <li>{i}</li>
                                                            })
                                                        }


                                                    </div>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                })
                            }


                        </Accordion>

                        {/* Add Step Button */}
                        <div className="d-flex justify-content-end mt-3">
                            <button className="modal-create-btn branchList-modal-cancel-btn-arbaz-responsive"
                                onClick={addStep}
                            >
                                + Add Step
                            </button>
                        </div>
                    </div>
                </Modal.Body>

                <div className="hr-line-modal">
                    <hr style={{ margin: 0 }} />
                </div>

                <Modal.Footer>
                    <div>
                        <button className="modal-cancel-btn"
                            onClick={() => setSHowTaskDetails(false)}>Close</button>
                        <button
                            className="modal-create-btn"
                            type='=button'
                            disabled={isSaving}
                            onClick={handlePublish}
                        >
                            {isSaving ? (
                                <div className="d-flex justify-content-center align-items-center">
                                    <ClipLoader color="#fff" size={18} className="me-2" />
                                </div>
                            ) : (
                                "Publish"
                            )}
                        </button>

                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )

})

export default CreateTaskPlanner